module.exports = __webpack_public_path__ + "img/icon-leopard.cb638017.png";